export default __webpack_public_path__ + "static/RH-logo-horizontal-inverse-b991a95b4d630bd9b6f447a65190da0e.svg";